// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "day__day-BGV9o";
var _3 = "day_selected-3Wnk8";
var _4 = "timelimit-1e5A-";
export { _1 as "__esModule", _2 as "day__day", _3 as "day_selected", _4 as "timelimit" }
export default { "__esModule": _1, "day__day": _2, "day_selected": _3, "timelimit": _4 }
